module.exports = __webpack_public_path__ + "img/emoji_77.eca76ed5.png";